export default "__VITE_ASSET__CJaOhX_b__"